import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ConfigService {

    public ip: string;
    public porta: string;
    public cdFilial: number;
    public cdCliente: number;
    public layout: number;
    public temaPadrao: string;

    private appConfig: any;

    constructor(private http: HttpClient) {}

    loadAppConfig(): Promise<void> {
        return this.http.get('assets/config/config.json')
        .toPromise()
        .then((config: any) => {
            this.appConfig = config;

            this.ip = config.configuracoes.enderecoIp;
            this.porta = config.configuracoes.porta;
            this.temaPadrao = config.temaBusiness.temaPadrao;
        });
    }

    getEndereco(): string {
        if (!this.ip || !this.porta) {
        const config = JSON.parse(localStorage.getItem("config"));
        return config.ip + ":" + config.porta;
        }
        return this.ip + ":" + this.porta;
    }

    getHeaders(): HttpHeaders {
        const token = localStorage.getItem('access_token') || "";
        return new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('authToken', token);
    }

    configuraService(config: ConfigService) {
        if (config) {
        this.cdFilial = config.cdFilial;
        this.cdCliente = config.cdCliente;
        }
    }

    loadAppTheme(){
        return this.temaPadrao;
    }
}
